import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import APIs from "../../APIs";
import { toast } from "react-toastify";

const EditProfile = () => {
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;

  const [user, setUser] = useState({
    full_name: "",
    email: "",
    mobile_number: "",
    user_type: "User Type",
  });

  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [countryList, setCountryList] = useState([])
  const [loading4, setLoading4] = useState(false);
  const [selectedCode, setSelectedCode] = useState([])
  // Fetch user data
  useEffect(() => {
    const fetchUser = async () => {
      if (!userId) return;
      try {
        const res = await APIs.post(
          "user/getUserById",
          { user_id: userId },
          { headers: { "Content-Type": "application/json" } }
        );
        if (res.data?.data) {

          setUser({
            full_name: res.data.data.full_name || "",
            email: res.data.data.email || "",
            mobile_number: res.data.data.mobile_number || "",
            user_type: res.data.data.user_type === "Individual" ? "Individual" : res.data.data.user_type || "User Type",
          });

        }
        getCountryApi(res.data.data.country_id)
        setLoading(false);
      } catch (err) {
        console.error("Error fetching user:", err);
        setLoading(false);
      }
    };
    fetchUser();
  }, [userId]);

  // Handle input changes
  const handleChange = (e) => {
    setUser({ ...user, [e.target.id]: e.target.value });
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    if (!user.full_name) newErrors.full_name = "Full Name is required";
    if (!user.email) newErrors.email = "Email is required";
    if (!user.mobile_number) newErrors.mobile_number = "Phone Number is required";
    if (!user.user_type || user.user_type === "User Type")
      newErrors.user_type = "Please select user type";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("user_id", userId);
    formData.append("full_name", user.full_name);
    formData.append("email", user.email);
    formData.append("mobile_number", user.mobile_number);
    formData.append("user_type", user.user_type);
    formData.append("country_id", selectedCode.country_id);
    formData.append("country_code", selectedCode.country_code);

    try {
      const res = await APIs.post("user/editProfile", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(res.data?.message || "Profile updated successfully");
      window.location.reload();
    } catch (err) {
      console.error("Error updating profile:", err);
      toast.error(err.response?.data?.message || "Failed to update profile");
    }
  };

  const getCountryApi = async (country_id) => {
    setLoading4(true)
    try {
      const response = await APIs.post("user/getCountry", {});
      console.log("getCountryApi Response:", response.data.data[0]);

      if (response.data.status == "success") {
        setLoading4(false)
        setCountryList(response.data.data)
        const matchedCountry = response.data.data.find(
          (c) => c.country_id === country_id
        );
        setSelectedCode(matchedCountry)
      } else {
        setLoading4(false)
        toast.error(response.data.message, { position: "top-right" });
      }
    } catch (error) {
      setLoading4(false)
      toast.error("Error getCountryApi", { position: "top-right" });
    } finally {
      setLoading4(false);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <>
      <div className="page-content">
        <section className="step-section-md">
          <div className="container">
            <div className="row">
              <div className="col-lg-3">
                <Sidebar />
              </div>
              <div className="col-lg-9">
                <div className="card mt-30">
                  <div className="card-header bg-white">
                    <h5 className="card-title">Edit Profile</h5>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label htmlFor="full_name" className="form-label">
                              Full Name
                            </label>
                            <input
                              className="form-control"
                              id="full_name"
                              type="text"
                              value={user.full_name}
                              onChange={handleChange}
                            />
                            {errors.full_name && <span className="text-danger">{errors.full_name}</span>}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                              Email
                            </label>
                            <input
                              className="form-control"
                              id="email"
                              type="email"
                              value={user.email}
                              onChange={handleChange}
                            />
                            {errors.email && <span className="text-danger">{errors.email}</span>}
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label htmlFor="mobile_number" className="form-label">
                              Phone Number
                            </label>

                            <div className="d-flex align-items-center">
                              {/* Country Code Dropdown */}
                              <select
                                value={selectedCode ? String(selectedCode.country_id) : ""}
                                onChange={(e) => {
                                  const selectedId = Number(e.target.value);
                                  const country = countryList.find(
                                    (c) => c.country_id === selectedId
                                  );
                                  setSelectedCode(country);
                                }}
                                style={{
                                  color: "black",
                                  background: "white",
                                  width: "120px",
                                  textAlign: "center",
                                  border: "1px solid #ced4da",
                                  borderRadius: "4px",
                                  outline: "none",
                                  boxShadow: "none",
                                  padding: "6px 4px",
                                  fontSize: "0.85rem",
                                  appearance: "none",
                                  WebkitAppearance: "none",
                                  MozAppearance: "none",
                                  marginRight: "8px",
                                }}
                              >
                                <option value="" hidden>
                                  Code
                                </option>

                                {countryList.map((c) => (
                                  <option key={c.country_id} value={String(c.country_id)}>
                                   {c.country_name} {c.country_code}
                                  </option>
                                ))}
                              </select>

                              {/* Mobile Input */}
                              <input
                                className="form-control"
                                id="mobile_number"
                                type="text"
                                value={user.mobile_number}
                                onChange={handleChange}
                                style={{ flex: 1 }}
                              />
                            </div>
                          </div>
                        </div>


                        <div className="col-md-6">
                          <div className="mb-3">
                            <label htmlFor="user_type" className="form-label">
                              User Type
                            </label>
                            <select
                              className="form-control select-control"
                              id="user_type"
                              value={user.user_type}
                              onChange={handleChange}
                            >
                              <option value="">User Type</option>
                              <option value="Individual">Individual Customer</option>
                              <option value="Corporate">Corporate</option>
                            </select>

                            {errors.user_type && <span className="text-danger">{errors.user_type}</span>}
                          </div>
                        </div>
                      </div>

                      <div className="card-footer bg-white">
                        <button type="submit" className="btn btn-success">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EditProfile;
